import React from 'react'
import { Link } from 'react-router-dom'
import Container from '@mui/material/Container'
import Stack from '@mui/material/Stack'
import Box from '@mui/material/Box'

import { UnAuthorizedVersion as LanguagePopover } from 'shared/components/LanguagePopover'

import logo from 'assets/images/logo-euromaster_2.jpg'
import { RootStyle, StyledLogo } from './styles'

export default function Header() {
   return (
      <RootStyle>
         <Container maxWidth="xl">
            <Stack direction="row" alignItems="center" justifyContent="space-between">
               <Box flex={{ xs: 0 }} sx={{ display: 'flex', gap: '24px' }} width={{ xs: '140px' }}>
                  <Link to="/">
                     <StyledLogo src={logo} alt="logo" />
                  </Link>
               </Box>
               <Box flex={{ xs: 0 }}>
                  <Stack direction="row" alignItems="center" justifyContent="space-between">
                     {/* {!user.roles.includes(UserRoles.DEMO) && !window.location.href.includes('demo') && (
                        <Link style={{ fontSize: '11px', textDecoration: 'none', color: 'white' }} to="/register">
                           <ContainedButton variant="contained" sx={{ mr: 3 }}>
                              {t('header.registerTitle')}
                           </ContainedButton>
                        </Link>
                     )} */}
                     <LanguagePopover />
                  </Stack>
               </Box>
            </Stack>
         </Container>
      </RootStyle>
   )
}
